export enum HttpMethods {
  POST = 'POST',
  GET = 'GET',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
  POST_OR_PUT = 'POST_OR_PUT'
}
